var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integrity-indicator",style:({ fontSize: _vm.size + 'px', lineHeight: 1 })},[_c('span',{staticClass:"integrity-badge",class:_vm.badgeClass},[_vm._v(_vm._s(_vm.percentage)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }